import React from "react";
import { ChangeEvent, Fragment, KeyboardEvent, MouseEvent } from "react";

import TreeView from "./TreeView";

import "./TreeView.css";

export interface ITreeViewItem {
    id: string;
    name: string;
    children?: ITreeViewItem[];
}

// tslint:disable-next-line:interface-name
export interface TreeViewEvent {
    origin: TreeViewItem | TreeView;
    index?: number;
    shortValue?: string;
    value?: string;
    parent?: ITreeViewItem;
    extra?: any;
}

interface ITreeViewItemProps {
    item: ITreeViewItem;
    index?: number;

    isTopLevel?: boolean;

    onNewItem?: (e: TreeViewEvent) => void;
    onRemoveItem?: (e: TreeViewEvent) => void;
    onUpdateItem?: (e: TreeViewEvent) => void;

    itemNameRender?: (item: any) => React.ReactChild;
}

interface ITreeViewItemState {
    isEdit: boolean;
    isOpen: boolean;

    isNewFocused: boolean;
    newItemText: string;
    newItemTextSecondary: string;
    newItemCpt: string;

    editItemText: string;
    editItemTextShort: string;
    editItemCpt: string;

    [name: string]: boolean | string;
}

class TreeViewItem extends React.Component<ITreeViewItemProps, ITreeViewItemState> {
    constructor(props: Readonly<ITreeViewItemProps>) {
        super(props);

        this.state = {
            isEdit: false,
            isOpen: false,

            isNewFocused: false,
            newItemText: "",
            newItemTextSecondary: "",
            newItemCpt: "",

            editItemText: "",
            editItemTextShort: "",
            editItemCpt: "",
        };

        this.toggleExpand = this.toggleExpand.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleInputKeydown = this.handleInputKeydown.bind(this);
        this.addItem = this.addItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.deleteItemSelf = this.deleteItemSelf.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.inputChanged = this.inputChanged.bind(this);
        this.focusNew = this.focusNew.bind(this);
        this.blurNew = this.blurNew.bind(this);
        this.editItemSelf = this.editItemSelf.bind(this);
    }

    public render() {
        const hasChildren = this.props.item.children && this.props.item.children.length > 0;

        return (
            <div>
                {
                    this.state.isEdit
                        ? <div className={"treeview-item-main-row" + (this.props.isTopLevel ? " treeview-header-clickable" : "")} tabIndex={hasChildren ? 0 : undefined} onClick={this.toggleExpand} onKeyDown={this.handleKeydown}>
                            <div className="treeview-item-input-left">
                                <input type="text" className="input-active" name="editItemText" value={this.state.editItemText} onChange={this.inputChanged} onKeyDown={this.handleInputKeydown} />
                                <input type="text" className="input-small input-active" name="editItemTextShort" value={this.state.editItemTextShort} onChange={this.inputChanged} onKeyDown={this.handleInputKeydown} placeholder="Short name" />
                                <input type="text" className="input-small input-active" name="editItemCpt" value={this.state.editItemCpt} onChange={this.inputChanged} onKeyDown={this.handleInputKeydown} placeholder="Cpt" />
                            </div>
                            <button type="button" className="button btn-light" onClick={this.editItemSelf}><i className="icon-check" /></button>
                        </div>
                        : <div className={"treeview-item-main-row" + (this.props.isTopLevel ? " treeview-header-clickable" : "")} tabIndex={hasChildren ? 0 : undefined} onClick={this.toggleExpand} onKeyDown={this.handleKeydown}>
                            {
                                this.props.isTopLevel
                                    ? <i className={`${this.state.isOpen ? "icon-chevron-down" : "icon-chevron-right"}`} />
                                    : ""
                            }
                            <span className="treeview-item-name">{this.props.itemNameRender ? this.props.itemNameRender(this.props.item) : this.props.item.name}</span>
                            <small>{(this.props.item as any).cpt || ""}</small>
                            <button type="button" className="button btn-light" onClick={this.editItemSelf}><i className="icon-pencil" /></button>
                            {
                                hasChildren
                                    ? ""
                                    : <button type="button" className="button btn-light" onClick={this.deleteItemSelf}><i className="icon-times" /></button>
                            }
                        </div>
                }
                {
                    this.state.isOpen && !this.state.isEdit
                        ? <Fragment>
                            <div className="treeview-item-list">
                                {this.props.item.children && this.props.item.children.map((a, i) => <TreeViewItem key={a.name} item={a} index={i} onRemoveItem={this.deleteItem} onUpdateItem={this.updateItem} itemNameRender={this.props.itemNameRender} />)}
                                {
                                    this.props.isTopLevel
                                        ? <div className="treeview-item-input">
                                            <div className="treeview-item-input-left">
                                                <input type="text" className={"input-light" + (this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary ? " input-active" : "")} placeholder={`Add ${this.props.item.name} option...`} name="newItemText" value={this.state.newItemText} onChange={this.inputChanged} onFocus={this.focusNew} onBlur={this.blurNew} onKeyDown={this.handleInputKeydown} />
                                                {this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary ? <input type="text" className={"input-light input-small input-active"} placeholder={this.state.isNewFocused ? "Short name" : ""} name="newItemTextSecondary" value={this.state.newItemTextSecondary} onChange={this.inputChanged} onFocus={this.focusNew} onBlur={this.blurNew} onKeyDown={this.handleInputKeydown} /> : ""}
                                                {this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary ? <input type="number" className={"input-light input-small input-active"} placeholder={this.state.isNewFocused ? "CPT" : ""} name="newItemCpt" value={this.state.newItemCpt} onChange={this.inputChanged} onFocus={this.focusNew} onBlur={this.blurNew} onKeyDown={this.handleInputKeydown} /> : ""}
                                            </div>
                                            {
                                                this.state.isNewFocused || this.state.newItemText || this.state.newItemTextSecondary
                                                    ? <button type="button" className="button" onClick={this.addItem} disabled={!this.state.newItemText}><i className="icon-plus" /></button>
                                                    : ""
                                            }
                                        </div>
                                        : ""
                                }
                            </div>
                        </Fragment>
                        : ""
                }
            </div>
        );
    }

    private toggleExpand(e?: MouseEvent<HTMLDivElement>) {
        if (e) {
            e.persist();
        }

        this.setState(s => {
            return { isOpen: !s.isOpen }
        });
    }

    private handleKeydown(e: KeyboardEvent<HTMLDivElement>) {
        if (e.key === "Enter" || (!this.state.isEdit && e.key === " ")) {
            e.preventDefault();
            this.toggleExpand();
        }
    }

    private handleInputKeydown(e: KeyboardEvent<HTMLInputElement>) {
        if (e.key === "Enter") {
            e.preventDefault();
            this.addItem();
        }
    }

    private addItem() {
        if (!this.state.newItemText) {
            return;
        }

        if (this.props.onNewItem) {
            this.props.onNewItem({
                origin: this,
                parent: this.props.item,
                shortValue: this.state.newItemTextSecondary,
                value: this.state.newItemText,

                extra: {
                    cpt: this.state.newItemCpt
                }
            });
        }

        this.setState({
            newItemText: "",
            newItemTextSecondary: "",
            newItemCpt: ""
        });
    }

    private deleteItem(e: TreeViewEvent) {
        if (this.props.onRemoveItem) {
            e.parent = this.props.item;
            this.props.onRemoveItem(e);
        }
    }

    private updateItem(e: TreeViewEvent) {
        if (this.props.onUpdateItem) {
            e.parent = this.props.item;
            this.props.onUpdateItem(e);
        }
    }

    private deleteItemSelf() {
        if (this.props.onRemoveItem) {
            this.props.onRemoveItem({
                index: this.props.index,
                origin: this
            });
        }
    }

    private inputChanged(e: ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            [name]: value
        });
    }

    private focusNew() {
        this.setState({ isNewFocused: true });
    }

    private blurNew() {
        if (this.state.newItemText) {
            this.setState({ isNewFocused: false });
        }
        else {
            this.setState({ isNewFocused: false, newItemTextSecondary: "", newItemCpt: "" });
        }
    }

    private editItemSelf() {
        if (this.state.isEdit) {
            if (this.props.onUpdateItem) {
                this.props.onUpdateItem({
                    index: this.props.index,
                    origin: this,

                    shortValue: this.state.editItemTextShort,
                    value: this.state.editItemText,

                    extra: {
                        cpt: this.state.editItemCpt
                    }
                });
            }

            this.setState({
                isEdit: false
            });
        }
        else {
            this.setState({
                isEdit: true,

                editItemText: this.props.item.name,
                editItemTextShort: (this.props.item as any).shortName,
                editItemCpt: (this.props.item as any).cpt
            });
        }
    }
}

export default TreeViewItem;